import { render } from "./footertop-u4.vue?vue&type=template&id=e3573bbe&scoped=true"
import script from "./footertop-u4.vue?vue&type=script&lang=js"
export * from "./footertop-u4.vue?vue&type=script&lang=js"

import "./footertop-u4.vue?vue&type=style&index=0&id=e3573bbe&scoped=true&lang=css"

import exportComponent from "../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3573bbe"]])

export default __exports__